"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var EventBus_1 = __importDefault(require("../../EventBus"));
var react_dom_1 = __importDefault(require("react-dom"));
var js_logger_1 = __importDefault(require("js-logger"));
var __1 = require("../..");
var popoutWindow;
var popoutContainer = document.createElement('div');
var closePopoutWindow = function () { return EventBus_1.default.Subject.next({ type: __1.constants.SET_PRESENTATION_LAYOUT_REQUEST, payload: __1.constants.SFU_PRES_LAYOUT_DEFAULT }); };
var WindowPortal = function (props) {
    var cleanUpPopout = react_1.useCallback(function () {
        // close window
        if (popoutWindow) {
            try {
                popoutWindow.close();
                popoutWindow = null;
                js_logger_1.default.info('Popout Window Closed');
            }
            catch (e) {
                js_logger_1.default.info('Unable to Close Popout Window');
            }
        }
    }, []);
    var closePopout = react_1.useCallback(function () {
        closePopoutWindow();
        cleanUpPopout();
    }, [cleanUpPopout, closePopoutWindow]);
    react_1.useEffect(function () {
        popoutWindow = window.open('', 'lsPopoutWindow', [
            'location=0',
            'menubar=0',
            'personalbar=0',
            'status=0',
            'titlebar=0',
            'toolbar=0',
            "height=" + window.innerHeight,
            "width=" + window.innerWidth // width of content area
        ].join(','));
        if (popoutWindow) {
            popoutWindow.document.title = props.windowName;
            popoutWindow.onunload = closePopout; // when the popout window is closed manually by closing the window
            popoutWindow.document.body.appendChild(popoutContainer);
        }
        if (!popoutWindow || popoutWindow.closed || typeof popoutWindow.closed === 'undefined') {
            js_logger_1.default.info('Popout Window Blocked');
            // TODO: open alert/snackbar to user
            closePopout();
        }
        return function () {
            cleanUpPopout();
        };
    }, [cleanUpPopout, closePopout]);
    return react_dom_1.default.createPortal(props.children, popoutContainer);
};
exports.default = WindowPortal;
